$(document).ready(function() {
  // Intercept login button click
  $('#login-button').on('click', function(e) {
    e.preventDefault();
    
    // Получаем данные из формы
    const email = $('#CustomerEmail').val();
    const password = $('#CustomerPassword').val();
    
    // Check if fields are filled
    if (!email || !password) {
      alert('Please fill in all fields');
      return;
    }
    
    
    // Show loading indicator
    const originalText = $('#login-button').html();
    $('#login-button').html('Signing in...').prop('disabled', true);
    
    // GraphQL mutation для получения токена
    const LOGIN_MUTATION = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }`;
    
    // First get access token via GraphQL
    $.ajax({
      url: `https://${shop_domain}/api/2024-04/graphql.json`,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        query: LOGIN_MUTATION,
        variables: {
          input: {
            email: email,
            password: password
          }
        }
      }),
      headers: {
        'X-Shopify-Storefront-Access-Token': api_key
      },
      success: function(response) {
        if (response.data && 
            response.data.customerAccessTokenCreate && 
            response.data.customerAccessTokenCreate.customerAccessToken) {
          
          // Get token
          const token = response.data.customerAccessTokenCreate.customerAccessToken.accessToken;
          const expiresAt = response.data.customerAccessTokenCreate.customerAccessToken.expiresAt;
          
          // Save token to localStorage
          localStorage.setItem('customerAccessToken', token);
          localStorage.setItem('customerAccessTokenExpiresAt', expiresAt);

          // Now login the user with the token
          $('#login-button').html(originalText).prop('disabled', false);
          
          // Нажимаем кнопку
          $('#login-button').off('click').click().html('Signing in...').prop('disabled', true);

        } else if (response.data.customerAccessTokenCreate.customerUserErrors.length > 0) {
          // Authentication error
          const errorMessage = response.data.customerAccessTokenCreate.customerUserErrors[0].message;
          alert('Authentication error: ' + errorMessage);
          $('#login-button').html(originalText).prop('disabled', false);
        } else {
          alert('Unknown error while getting token');
          $('#login-button').html(originalText).prop('disabled', false);
        }
      },
      error: function(xhr, status, error) {
        console.error('Error getting token:', error);
        alert('Error getting access token');
        $('#login-button').html(originalText).prop('disabled', false);
      }
    });
  });
  
  // Обработчик для формы восстановления пароля
  $('#recover-button').on('click', function(e) {
    e.preventDefault();
    
    const email = $('#RecoverEmail').val();
    
    if (!email) {
      alert('Please enter your email address');
      return;
    }
    
    // Показываем индикатор загрузки
    const originalText = $('#recover-button').html();
    $('#recover-button').html('Sending...').prop('disabled', true);
    
    // Отправляем AJAX запрос для восстановления пароля
    $.ajax({
      url: '/account/recover',
      method: 'POST',
      data: {
        'customer[email]': email,
        'form_type': 'recover_customer_password',
        'utf8': '✓'
      },
      success: function(response, textStatus, xhr) {
        if (xhr.status === 200) {
          if (response.includes('form__message') || response.includes('error')) {
            // Есть ошибки
            $('#forgot_password_msg').html('<div class="alert alert-danger">Error sending recovery email. Please try again.</div>');
          } else {
            // Успешно отправлено
            $('#forgot_password_msg').html('<div class="alert alert-success">We\'ve sent you an email with a link to update your password.</div>');
            $('#RecoverEmail').val('');
          }
        } else {
          $('#forgot_password_msg').html('<div class="alert alert-danger">Server error. Please try again.</div>');
        }
      },
      error: function(xhr, status, error) {
        console.error('Error sending recovery email:', error);
        $('#forgot_password_msg').html('<div class="alert alert-danger">Error sending recovery email. Please try again.</div>');
      },
      complete: function() {
        // Восстанавливаем кнопку
        $('#recover-button').html(originalText).prop('disabled', false);
      }
    });
  });
  
  // Обработчик для формы регистрации
  /*$('#create-account-button').on('click', function(e) {
    e.preventDefault();
    
    // Получаем данные из формы
    const firstName = $('#RegisterForm-FirstName').val();
    const lastName = $('#RegisterForm-LastName').val();
    const email = $('#RegisterForm-email').val();
    const password = $('#RegisterForm-password').val();
    
    // Валидация полей
    if (!firstName || !lastName || !email || !password) {
      alert('Please fill in all fields');
      return;
    }
    
    // Показываем индикатор загрузки
    const originalText = $('#create-account-button').html();
    $('#create-account-button').html('Creating Account...').prop('disabled', true);
    
    // Отправляем AJAX запрос для регистрации
    $.ajax({
      url: '/account/register',
      method: 'POST',
      data: {
        'customer[first_name]': firstName,
        'customer[last_name]': lastName,
        'customer[email]': email,
        'customer[password]': password,
        'form_type': 'create_customer',
        'utf8': '✓'
      },
      success: function(response, textStatus, xhr) {
        if (xhr.status === 200) {
          if (response.includes('form__message') || response.includes('error')) {
            // Есть ошибки
            handleRegistrationError(response);
          } else {
            // Успешная регистрация
            handleRegistrationSuccess();
          }
        } else {
          $('#create_account_msg').html('<div class="alert alert-danger">Server error. Please try again.</div>');
        }
      },
      error: function(xhr, status, error) {
        console.error('Error creating account:', error);
        if (xhr.status === 422) {
          // Ошибка валидации
          handleRegistrationError(xhr.responseText);
        } else {
          $('#create_account_msg').html('<div class="alert alert-danger">Error creating account. Please try again.</div>');
        }
      },
      complete: function() {
        // Восстанавливаем кнопку
        $('#create-account-button').html(originalText).prop('disabled', false);
      }
    });
  });*/
});

// Функция для обработки успешной регистрации
function handleRegistrationSuccess() {
  $('#create_account_msg').html('<div class="alert alert-success">Account created successfully! Please check your email to activate your account.</div>');
  
  // Очищаем форму
  $('#RegisterForm-FirstName').val('');
  $('#RegisterForm-LastName').val('');
  $('#RegisterForm-email').val('');
  $('#RegisterForm-password').val('');
  
  // Через 3 секунды переключаемся на форму входа
  setTimeout(function() {
    show_login();
  }, 3000);
}

// Функция для обработки ошибок регистрации
function handleRegistrationError(response) {
  // Пытаемся извлечь сообщение об ошибке из HTML ответа
  let errorMessage = 'Error creating account. Please check your information and try again.';
  
  // Создаем временный элемент для парсинга HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = response;
  
  // Ищем сообщения об ошибках
  const errorElements = tempDiv.querySelectorAll('.form__message, .errors, .field__message');
  if (errorElements.length > 0) {
    errorMessage = errorElements[0].textContent.trim();
  }
  
  // Показываем сообщение об ошибке
  $('#create_account_msg').html('<div class="alert alert-danger">' + errorMessage + '</div>');
  
  // Очищаем поле пароля
  $('#RegisterForm-password').val('');
}

// Функция для выхода пользователя
function logoutUser() {
  localStorage.removeItem('customerAccessToken');
  localStorage.removeItem('customerAccessTokenExpiresAt');
  
  // Перенаправляем на главную страницу
  window.location.href = '/';
}

$(document).ready(function() {
  // Configuration
  const SHOP_DOMAIN = shop_domain;
  const STOREFRONT_ACCESS_TOKEN = api_key;
  
  // Обработчик отправки формы адреса
  $(document).on('submit', '#address_edit_form', handleAddressFormSubmit);
  
  // Обработчик для отправки формы входа по Enter
  $(document).on('keypress', '#CustomerEmail, #CustomerPassword', function(e) {
    if (e.which === 13) { // Enter key
      e.preventDefault();
      send_login();
    }
  });

  const LOGIN_MUTATION = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `;

  // Intercept login button click
  
   
 
});
/** ********************* */
/**
 * Format phone number to E.164 format for Shopify API
 * Converts UK numbers starting with 0 to +44 format
 */
function formatPhoneE164(phone) {
    if (!phone) return phone;

    // Remove all spaces, dashes, and parentheses
    var cleaned = phone.replace(/[\s\-\(\)]/g, '');

    // If already has + prefix, assume it's already formatted
    if (cleaned.startsWith('+')) {
        return cleaned;
    }

    // UK numbers: convert 07xxx to +447xxx
    if (cleaned.startsWith('0') && cleaned.length === 11) {
        return '+44' + cleaned.substring(1);
    }

    // If starts with 44 (no plus), add the plus
    if (cleaned.startsWith('44') && cleaned.length === 12) {
        return '+' + cleaned;
    }

    // Return cleaned number as-is if format not recognized
    return cleaned;
}

function UpadateCustomerContactData(){
    var customerAccessToken = localStorage.getItem('customerAccessToken');

    // Check if token exists
    if (!customerAccessToken) {
      showErrorMessage('Session expired. Please log out and log back in to update your information.');
      return;
    }

    var email = $('#customer_email').val();
    var phone = formatPhoneE164($('#customer_phone').val());

    // Update customer contact info
    var customerQuery = `
      mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
        customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
          customer {
            id
            email
            phone
          }
          customerUserErrors {
            field
            message
          }
        }
      }
    `;

    // Block the "Update Contact Data" button during request execution
    var $updateBtn = $('#update_customer_contact_data_btn');
    var originalBtnText = $updateBtn.val();
    $updateBtn.prop('disabled', true).val('Saving...');

    var customerVariables = {
      customerAccessToken: customerAccessToken,
      customer: {
        email: email,
        phone: phone
      }
    }; 

    // Update customer contact info
    $.ajax({
      url: `https://${shop_domain}/api/2024-10/graphql.json`,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ query: customerQuery, variables: customerVariables }),
      headers: {
        'X-Shopify-Storefront-Access-Token': api_key
      },
      success: function(response) {
        if (response.data && response.data.customerUpdate && response.data.customerUpdate.customer) {
          showSuccessMessage('Contact data updated successfully!');
          update_block('contacts_module_wr','view');

          $('#customer_email_td').text(email);
          $('#customer_phone_td').text(phone);
          $updateBtn.prop('disabled', false).val(originalBtnText);

        } else if (response.data.customerUpdate.customerUserErrors.length) {
          showErrorMessage('Error: ' + response.data.customerUpdate.customerUserErrors[0].message);
          $updateBtn.prop('disabled', false).val(originalBtnText);
        } else {
          showErrorMessage('Unknown error');
          $updateBtn.prop('disabled', false).val(originalBtnText);
        }
      },
      error: function() {
        showErrorMessage('Error sending request');
        $updateBtn.prop('disabled', false).val(originalBtnText);
      }
    });

}  
// Handle customer profile form submission via Storefront API
// Uses Customer Note workaround for DOB/Gender since Storefront API cannot write metafields
$(document).on('submit', '#customer_profile_form', function(e) {
  e.preventDefault();
  UpdateCustomerProfileData();
});

/**
 * Update Customer Profile Data
 * Sends all profile data to Cloudflare Worker which handles:
 * - firstName/lastName via Storefront API
 * - DOB/Gender via Admin API (metafields)
 */
function UpdateCustomerProfileData() {
  var customerAccessToken = localStorage.getItem('customerAccessToken');

  if (!customerAccessToken) {
    showErrorMessage('Session expired. Please log out and log back in.');
    return;
  }

  // Get values from inputs
  var firstName = $('#customer_firstname').val();
  var lastName = $('#customer_lastname').val();
  var dob = $('#customer_dob').val();
  var gender = $('#customer_gender').val();

  // Show loading state
  var $btn = $('#update_customer_data_btn');
  var originalText = $btn.text() || $btn.val();
  $btn.prop('disabled', true).text('Saving...');

  // Get customer ID from hidden field (set by Liquid)
  var customerId = $('#shopify_customer_id').val();

  if (!customerId) {
    showErrorMessage('Customer ID not found. Please refresh the page.');
    $btn.prop('disabled', false).text(originalText);
    return;
  }

  // Send to Cloudflare Worker
  $.ajax({
    url: 'https://shopify-profile-proxy.fredcassman.workers.dev',
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      customerId: customerId,
      token: customerAccessToken,
      firstName: firstName,
      lastName: lastName,
      dob: dob,
      gender: gender
    }),
    success: function(response) {
      $btn.prop('disabled', false).text(originalText);

      if (response.success) {
        showSuccessMessage('Profile updated successfully!');

        // Update the view mode display
        $('#customer_firstname_td').text(firstName);
        $('#customer_lastname_td').text(lastName);
        $('#customer_dob_td').text(dob || '');
        $('#customer_gender_td').text(gender || 'Not specified');

        // Switch back to view mode
        update_block('personal_information_module_wr', 'view');
      } else {
        console.error('Worker Error:', response.message);
        showErrorMessage('Error: ' + response.message);
      }
    },
    error: function(xhr, status, error) {
      $btn.prop('disabled', false).text(originalText);
      console.error('AJAX Error:', error);
      console.error('Response Text:', xhr.responseText);
      // Show the worker's own message (e.g. "Session expired. Please log out and log back in.")
      var workerMessage = null;
      try { workerMessage = JSON.parse(xhr.responseText).message; } catch (e) {}
      showErrorMessage(workerMessage || 'Connection error. Please try again.');
    }
  });
}

// Convert numeric address ID to GraphQL global ID format
function formatAddressId(addressId) {
  if (!addressId) return null;
  // If already in gid format, return as-is
  if (addressId.toString().startsWith('gid://')) {
    return addressId;
  }
  // Convert numeric ID to GraphQL global ID
  return 'gid://shopify/MailingAddress/' + addressId + '?model_name=CustomerAddress';
}

function SaveAddress(){
  var customerAccessToken = localStorage.getItem('customerAccessToken');

  // Check if token exists
  if (!customerAccessToken) {
    showErrorMessage('Session expired. Please log out and log back in to manage addresses.');
    return;
  }

  var addressId = $('#address_id').val();

  // Collect form data
  var addressData = {
    firstName: $('#addresses_first_name').val(),
    lastName: $('#addresses_last_name').val(),
    company: $('#addresses_company').val(),
    address1: $('#addresses_address1').val(),
    address2: $('#addresses_address2').val(),
    city: $('#addresses_city').val(),
    zip: $('#addresses_zip').val(),
    country: $('#addresses_country').val(),
    phone: formatPhoneE164($('#addresses_phone').val())
  };

  // Validate required fields
  if (!addressData.firstName || !addressData.lastName || !addressData.address1 || !addressData.city || !addressData.country) {
    showErrorMessage('Please fill in all required fields');
    return;
  }

  var mutation, variables;

  if (addressId) {
    // Convert ID to GraphQL format if needed
    var graphqlAddressId = formatAddressId(addressId);

    // Update existing address
    mutation = `
      mutation customerAddressUpdate($customerAccessToken: String!, $id: ID!, $address: MailingAddressInput!) {
        customerAddressUpdate(customerAccessToken: $customerAccessToken, id: $id, address: $address) {
          customerAddress {
            id
            firstName
            lastName
            company
            address1
            address2
            city
            province
            zip
            country
            phone
          }
          customerUserErrors {
            field
            message
          }
        }
      }
    `;

    variables = {
      customerAccessToken: customerAccessToken,
      id: graphqlAddressId,
      address: addressData
    };
  } else {
    // Create new address
    mutation = `
      mutation customerAddressCreate($customerAccessToken: String!, $address: MailingAddressInput!) {
        customerAddressCreate(customerAccessToken: $customerAccessToken, address: $address) {
          customerAddress {
            id
            firstName
            lastName
            company
            address1
            address2
            city
            province
            zip
            country
            phone
          }
          customerUserErrors {
            field
            message
          }
        }
      }
    `;

    variables = {
      customerAccessToken: customerAccessToken,
      address: addressData
    };
  }

  // Disable submit button
  var $submitBtn = $('#address_submit_btn');
  var originalText = $submitBtn.val();
  $submitBtn.prop('disabled', true).val('Saving...');

  $.ajax({
    url: `https://${shop_domain}/api/2024-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ query: mutation, variables: variables }),
    headers: {
      'X-Shopify-Storefront-Access-Token': api_key
    },
    success: function(response) {
      if (response.errors) {
        console.error('GraphQL errors:', response.errors);
        showErrorMessage('API Error: ' + response.errors[0].message);
        $submitBtn.prop('disabled', false).val(originalText);
        return;
      }

      if (response.data) {
        var result = addressId ?
          response.data.customerAddressUpdate :
          response.data.customerAddressCreate;

        if (result && result.customerAddress) {
          var savedAddressId = result.customerAddress.id;
          var setAsDefault = $('#address_default_address').is(':checked');

          if (setAsDefault) {
            // Set as default address
            setDefaultAddress(savedAddressId, customerAccessToken, function() {
              showSuccessMessage(addressId ? 'Address updated and set as default!' : 'Address added and set as default!');
              finishAddressSave();
            }, function(errorMsg) {
              showSuccessMessage(addressId ? 'Address updated successfully!' : 'Address added successfully!');
              showErrorMessage('Could not set as default: ' + errorMsg);
              finishAddressSave();
            });
          } else {
            showSuccessMessage(addressId ? 'Address updated successfully!' : 'Address added successfully!');
            finishAddressSave();
          }

          function finishAddressSave() {
            // Clear form and return to view mode
            $('#address_id').val('');
            $('.address_edit_title').text('Add New Address');
            $('#address_submit_btn').val('Add Address');
            $('#address_default_address').prop('checked', false);

            update_block('addresses_module_wr', 'view');

            // Reload page to refresh addresses from server
            setTimeout(function() {
              window.location.reload();
            }, 1000);
          }

        } else if (result && result.customerUserErrors && result.customerUserErrors.length > 0) {
          showErrorMessage('Error: ' + result.customerUserErrors[0].message);
        } else {
          showErrorMessage('Unknown error occurred');
        }
      } else {
        showErrorMessage('Error processing request');
      }

      $submitBtn.prop('disabled', false).val(originalText);
    },
    error: function(xhr, status, error) {
      console.error('Address save error:', error, xhr.responseText);
      showErrorMessage('Error connecting to server. Check console for details.');
      $submitBtn.prop('disabled', false).val(originalText);
    }
  });
}

function setDefaultAddress(addressId, customerAccessToken, onSuccess, onError) {
  var mutation = `
    mutation customerDefaultAddressUpdate($customerAccessToken: String!, $addressId: ID!) {
      customerDefaultAddressUpdate(customerAccessToken: $customerAccessToken, addressId: $addressId) {
        customer {
          id
          defaultAddress {
            id
          }
        }
        customerUserErrors {
          field
          message
        }
      }
    }
  `;

  $.ajax({
    url: `https://${shop_domain}/api/2024-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      query: mutation,
      variables: {
        customerAccessToken: customerAccessToken,
        addressId: addressId
      }
    }),
    headers: {
      'X-Shopify-Storefront-Access-Token': api_key
    },
    success: function(response) {
      if (response.errors) {
        console.error('Set default address errors:', response.errors);
        onError(response.errors[0].message);
        return;
      }

      var result = response.data.customerDefaultAddressUpdate;
      if (result && result.customerUserErrors && result.customerUserErrors.length > 0) {
        onError(result.customerUserErrors[0].message);
      } else {
        onSuccess();
      }
    },
    error: function(xhr, status, error) {
      console.error('Set default address error:', error);
      onError('Network error');
    }
  });
}

function add_address(){
  update_block('addresses_module_wr','edit');
  $('.address_edit_title').text('Add New Address');
  $('#address_submit_btn').val('Add Address');
  $('#address_id').val(''); // Clear any existing address ID
  
  // Clear all form fields
  $('#addresses_first_name').val('');
  $('#addresses_last_name').val('');
  $('#addresses_company').val('');
  $('#addresses_address1').val('');
  $('#addresses_address2').val('');
  $('#addresses_city').val('');
  $('#addresses_zip').val('');
  $('#addresses_phone').val('');
  $('#addresses_country').val('');
  
  // Uncheck default address checkbox
  $('#address_default_address').prop('checked', false);
}

function edit_address(address_id){
  // Показываем форму редактирования
  update_block('addresses_module_wr','edit');
  $('.address_edit_title').text('Edit Address');
  
  // Используем загруженные адреса из глобальной переменной
  if (window.customerAddresses) {
    var targetAddress = window.customerAddresses.find(addr => addr.id === address_id);
    
    if (targetAddress) {
      // Заполняем форму данными адреса
      $('#addresses_first_name').val(targetAddress.firstName || '');
      $('#addresses_last_name').val(targetAddress.lastName || '');
      $('#addresses_company').val(targetAddress.company || '');
      $('#addresses_address1').val(targetAddress.address1 || '');
      $('#addresses_address2').val(targetAddress.address2 || '');
      $('#addresses_city').val(targetAddress.city || '');
      $('#addresses_zip').val(targetAddress.zip || '');
      $('#addresses_phone').val(targetAddress.phone || '');
      
      // Set country
      if (targetAddress.country) {
        $('#addresses_country').val(targetAddress.country);
      }
      
      // Сохраняем ID адреса для последующего обновления (уже в base64 формате)
      $('#address_id').val(address_id);
      
      // Меняем заголовок формы
      $('.address_edit_title').text('Edit Address');
      
      // Меняем кнопку на "Update Address"
      $('#address_submit_btn').val('Update Address');

      // Check if this is the default address
      var isDefault = window.customerDefaultAddress && window.customerDefaultAddress.id === address_id;
      $('#address_default_address').prop('checked', isDefault);
    } else {
      showErrorMessage('Address not found');
    }
  } else {
    // Если адреса не загружены, загружаем их
    load_addresses();
    setTimeout(function() {
      edit_address(address_id);
    }, 1000);
  }
}



function delete_address(address_id){
  // Confirm deletion
  if (!confirm('Are you sure you want to delete this address? This action cannot be undone.')) {
    return;
  }

  var customerAccessToken = localStorage.getItem('customerAccessToken');

  if (!customerAccessToken) {
    showErrorMessage('Session expired. Please log out and log back in to manage addresses.');
    return;
  }

  // Convert ID to GraphQL format if needed
  var graphqlAddressId = formatAddressId(address_id);

  var deleteMutation = `
    mutation customerAddressDelete($customerAccessToken: String!, $id: ID!) {
      customerAddressDelete(customerAccessToken: $customerAccessToken, id: $id) {
        deletedCustomerAddressId
        customerUserErrors {
          field
          message
        }
      }
    }
  `;

  var variables = {
    customerAccessToken: customerAccessToken,
    id: graphqlAddressId
  };

  // Show loading indicator
  showSuccessMessage('Deleting address...');

  $.ajax({
    url: `https://${shop_domain}/api/2024-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ query: deleteMutation, variables: variables }),
    headers: {
      'X-Shopify-Storefront-Access-Token': api_key
    },
    success: function(response) {
      if (response.errors) {
        console.error('Delete address error:', response.errors);
        showErrorMessage('API Error: ' + response.errors[0].message);
        return;
      }

      if (response.data && response.data.customerAddressDelete) {
        var result = response.data.customerAddressDelete;

        if (result.deletedCustomerAddressId) {
          showSuccessMessage('Address deleted successfully!');

          // Reload page to refresh addresses
          setTimeout(function() {
            window.location.reload();
          }, 1000);

        } else if (result.customerUserErrors && result.customerUserErrors.length > 0) {
          showErrorMessage('Error: ' + result.customerUserErrors[0].message);
        } else {
          showErrorMessage('Unknown error occurred while deleting address');
        }
      } else {
        showErrorMessage('Error processing delete request');
      }
    },
    error: function(xhr, status, error) {
      console.error('Error deleting address:', error, xhr.responseText);
      showErrorMessage('Error connecting to server. Check console for details.');
    }
  });
}

// Функция для отмены редактирования адреса
function cancelAddressEdit() {
  // Очищаем форму
  $('#address_id').val('');
  
  // Возвращаем заголовок и кнопку в исходное состояние
  $('.address_edit_title').text('Add New Address');
  $('#address_submit_btn').val('Add Address');
  
  // Переключаемся на режим просмотра
  update_block('addresses_module_wr', 'view');
}

// Handle address form submission
function handleAddressFormSubmit(event) {
  event.preventDefault();

  var customerAccessToken = localStorage.getItem('customerAccessToken');

  // Check if token exists
  if (!customerAccessToken) {
    showErrorMessage('Session expired. Please log out and log back in to manage addresses.');
    return;
  }

  var addressId = $('#address_id').val();

  // Collect form data
  var addressData = {
    firstName: $('#addresses_first_name').val(),
    lastName: $('#addresses_last_name').val(),
    company: $('#addresses_company').val(),
    address1: $('#addresses_address1').val(),
    address2: $('#addresses_address2').val(),
    city: $('#addresses_city').val(),
    zip: $('#addresses_zip').val(),
    country: $('#addresses_country').val(),
    phone: formatPhoneE164($('#addresses_phone').val())
  };

  // Проверяем обязательные поля
  if (!addressData.firstName || !addressData.lastName || !addressData.address1 || !addressData.city || !addressData.country) {
    showErrorMessage('Please fill in all required fields');
    return;
  }
  
  var mutation, variables;
  
  if (addressId) {
    // Convert ID to GraphQL format if needed
    var graphqlAddressId = formatAddressId(addressId);

    // Update existing address
    mutation = `
      mutation customerAddressUpdate($customerAccessToken: String!, $id: ID!, $address: MailingAddressInput!) {
        customerAddressUpdate(customerAccessToken: $customerAccessToken, id: $id, address: $address) {
          customerAddress {
            id
            firstName
            lastName
            company
            address1
            address2
            city
            province
            zip
            country
            phone
          }
          customerUserErrors {
            field
            message
          }
        }
      }
    `;

    variables = {
      customerAccessToken: customerAccessToken,
      id: graphqlAddressId,
      address: addressData
    };
  } else {
    // Create new address
    mutation = `
      mutation customerAddressCreate($customerAccessToken: String!, $address: MailingAddressInput!) {
        customerAddressCreate(customerAccessToken: $customerAccessToken, address: $address) {
          customerAddress {
            id
            firstName
            lastName
            company
            address1
            address2
            city
            province
            zip
            country
            phone
          }
          customerUserErrors {
            field
            message
          }
        }
      }
    `;
    
    variables = {
      customerAccessToken: customerAccessToken,
      address: addressData
    };
  }
  
  // Блокируем кнопку
  var $submitBtn = $('#address_submit_btn');
  var originalText = $submitBtn.val();
  $submitBtn.prop('disabled', true).val('Saving...');
  
  $.ajax({
    url: `https://${shop_domain}/api/2024-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ query: mutation, variables: variables }),
    headers: {
      'X-Shopify-Storefront-Access-Token': api_key
    },
    success: function(response) {
      if (response.data) {
        var result = addressId ? 
          response.data.customerAddressUpdate : 
          response.data.customerAddressCreate;
          
        if (result && result.customerAddress) {
          showSuccessMessage(addressId ? 'Address updated successfully!' : 'Address added successfully!');
          
          // Очищаем форму и возвращаемся к просмотру
          $('#address_edit_form')[0].reset();
          $('#address_id').val('');
          $('.address_edit_title').text('Add New Address');
          $('#address_submit_btn').val('Add Address');
          
          update_block('addresses_module_wr', 'view');
          
          // Перезагружаем адреса для обновления списка
          setTimeout(function() {
            load_addresses();
          }, 1000);
          
        } else if (result && result.customerUserErrors && result.customerUserErrors.length > 0) {
          showErrorMessage('Error: ' + result.customerUserErrors[0].message);
        } else {
          showErrorMessage('Unknown error occurred');
        }
      } else {
        showErrorMessage('Error processing request');
      }
      
      $submitBtn.prop('disabled', false).val(originalText);
    },
    error: function() {
      showErrorMessage('Error connecting to server');
      $submitBtn.prop('disabled', false).val(originalText);
    }
  });
}

function SaveNewsletterSubscription(){
  var customerAccessToken = localStorage.getItem('customerAccessToken');

  if (!customerAccessToken) {
    showErrorMessage('Session expired. Please log out and log back in to update your subscription preferences.');
    return;
  }

  var subscribe = $('#email_subscribed').is(':checked');
  var consentWorkerUrl = typeof newsletter_consent_worker_url === 'string'
    ? newsletter_consent_worker_url.trim()
    : '';

  if (!consentWorkerUrl) {
    showErrorMessage('Email preference service is not configured. Please contact support.');
    return;
  }

  var $submitBtn = $('.newsletter-subscription-form button[type="submit"]');
  var originalText = $submitBtn.text();
  $submitBtn.prop('disabled', true).text('Saving...');

  var endpoint = consentWorkerUrl.replace(/\/$/, '') + '/consent/email';

  $.ajax({
    url: endpoint,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      customerAccessToken: customerAccessToken,
      subscribe: subscribe
    }),
    success: function(response) {
      if (response && response.success) {
        showSuccessMessage(response.message || 'Your subscription preferences have been updated successfully!');
      } else if (response && response.message) {
        showErrorMessage(response.message);
      } else {
        showErrorMessage('Unable to fully update your subscription preferences. Please try again.');
      }

      $submitBtn.prop('disabled', false).text(originalText);
    },
    error: function(xhr) {
      if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
        showErrorMessage(xhr.responseJSON.message);
      } else {
        showErrorMessage('Error connecting to email preference service');
      }
      $submitBtn.prop('disabled', false).text(originalText);
    }
  });
}

// Функции для показа сообщений
function showSuccessMessage(message) {
  // Создаем элемент для сообщения
  var $message = $('<div class="alert alert-success" style="position: fixed; top: 20px; right: 20px; z-index: 9999; padding: 15px; border-radius: 5px; background: #d4edda; color: #155724; border: 1px solid #c3e6cb;">' + message + '</div>');
  
  // Добавляем на страницу
  $('body').append($message);
  
  // Удаляем через 3 секунды
  setTimeout(function() {
    $message.fadeOut(function() {
      $(this).remove();
    });
  }, 3000);
}

// Check token validity on page load
function checkTokenValidity() {
  var customerAccessToken = localStorage.getItem('customerAccessToken');
  var tokenExpiresAt = localStorage.getItem('customerAccessTokenExpiresAt');

  // Check if token exists
  if (!customerAccessToken) {
    showTokenWarning();
    return false;
  }

  // Check if token is expired
  if (tokenExpiresAt) {
    var expiryDate = new Date(tokenExpiresAt);
    var now = new Date();
    if (now >= expiryDate) {
      // Token is expired, clear it
      localStorage.removeItem('customerAccessToken');
      localStorage.removeItem('customerAccessTokenExpiresAt');
      showTokenWarning();
      return false;
    }
  }

  return true;
}

// Redirect to login when token is missing (e.g., after account activation)
function showTokenWarning() {
  if ($('#token-warning-banner').length > 0) return;

  var warningHTML = '<div id="token-warning-banner" style="background: #fff3cd; border: 1px solid #ffc107; color: #856404; padding: 15px; margin-bottom: 20px; border-radius: 5px; display: flex; justify-content: space-between; align-items: center;">' +
    '<span><strong>Session Notice:</strong> To edit your profile or addresses, please <a href="/account/logout" style="color: #856404; text-decoration: underline;">log out</a> and log back in.</span>' +
    '<button onclick="$(this).parent().fadeOut();" style="background: none; border: none; font-size: 20px; cursor: pointer; color: #856404;">&times;</button>' +
    '</div>';

  if ($('#account-section').length) {
    $('#account-section').prepend(warningHTML);
  } else if ($('.customer').length) {
    $('.customer').first().prepend(warningHTML);
  }
}

$(document).ready(function(){
  // Check token validity on account pages
  if ($('#account-section').length || $('#addresses_module_wr').length) {
    checkTokenValidity();
  }

  if( $('#addresses_module_wr').length > 0 ){
    load_addresses();
  }
});

/** Load all customer addresses */
function load_addresses(){
  var customerAccessToken = localStorage.getItem('customerAccessToken');

  if (!customerAccessToken) {
    // Addresses are still shown from Liquid template, just API updates won't work
    return;
  }
  
  // GraphQL query to get customer addresses
  var addressQuery = `
    query getCustomerAddresses($customerAccessToken: String!) {
      customer(customerAccessToken: $customerAccessToken) {
        addresses(first: 20) {
          edges {
            node {
              id
              firstName
              lastName
              company
              address1
              address2
              city
              province
              zip
              country
              phone
            }
          }
        }
        defaultAddress {
          id
          firstName
          lastName
          company
          address1
          address2
          city
          province
          zip
          country
          phone
        }
      }
    }
  `;

  var variables = {
    customerAccessToken: customerAccessToken
  };

  // Execute the request
  $.ajax({
    url: `https://${shop_domain}/api/2024-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ query: addressQuery, variables: variables }),
    headers: {
      'X-Shopify-Storefront-Access-Token': api_key
    },
    success: function(response) {
      try {
        if (response.data && response.data.customer) {
          var addresses = [];
          var defaultAddress = response.data.customer.defaultAddress;
          
          // Get all addresses
          if (response.data.customer.addresses && response.data.customer.addresses.edges) {
            addresses = response.data.customer.addresses.edges.map(edge => edge.node);
          }
          
          // Store addresses in global variable for later use
          window.customerAddresses = addresses;
          window.customerDefaultAddress = defaultAddress;

          // Update the addresses display
          updateAddressesDisplay(addresses, defaultAddress);
          
        } else {
          console.error('No customer data received');
        }
      } catch (e) {
        console.error('Error processing addresses:', e);
      }
    },
    error: function(xhr, status, error) {
      console.error('Error loading addresses:', error);
    }
  });
}

// Function to update the addresses display
function updateAddressesDisplay(addresses, defaultAddress) {
  var $addressesContainer = $('#addresses_module_wr .mist_bl_c_view');
  
  if (!addresses || addresses.length === 0) {
    $addressesContainer.html('<p>No addresses found. <a href="javascript:void(0)" onclick="add_address()">Add your first address</a></p>');
    return;
  }
  
  var html = '';
  
  // Show default address first if it exists
  if (defaultAddress) {
    html += createAddressHTML(defaultAddress, true);
  }
  
  // Show all other addresses
  addresses.forEach(function(address) {
    if (!defaultAddress || address.id !== defaultAddress.id) {
      html += createAddressHTML(address, false);
    }
  });
  
  $addressesContainer.html(html);
}

// Function to create HTML for a single address
function createAddressHTML(address, isDefault) {
  var addressId = address.id; // This is already in base64 format from GraphQL
  
  var html = '<div class="address_item_wr' + (isDefault ? ' default_address' : '') + '">';
  html += '<div class="address_item">';
  html += '<div class="address-name">' + (address.firstName || '') + ' ' + (address.lastName || '') + '</div>';
  
  if (address.company) {
    html += '<div class="address-company">' + address.company + '</div>';
  }
  
  html += '<div class="address-street">' + (address.address1 || '') + '</div>';
  
  if (address.address2) {
    html += '<div class="address-street">' + address.address2 + '</div>';
  }
  
  var cityStateZip = address.city || '';
  if (address.province) {
    cityStateZip += (cityStateZip ? ', ' : '') + address.province;
  }
  if (address.zip) {
    cityStateZip += (cityStateZip ? ' ' : '') + address.zip;
  }
  html += '<div class="address-city-state">' + cityStateZip + '</div>';
  
  html += '<div class="address-country">' + (address.country || '') + '</div>';
  
  if (address.phone) {
    html += '<div class="address-phone">' + address.phone + '</div>';
  }
  
  html += '</div>';
  html += '<div class="address_item_btns" style="display: flex;">';
  html += '<a href="javascript:void(0)" onclick="edit_address(\'' + addressId + '\');" class="bt_sm_1">Edit <i class="fa fa-pencil"></i></a>&nbsp;';
  html += '<a href="javascript:void(0)" onclick="delete_address(\'' + addressId + '\');" class="bt_sm_1">Delete <i class="fa fa-trash-o"></i></a>';
  html += '</div>';
  html += '</div>';
  
  return html;
}

function showErrorMessage(message) {
  // Создаем элемент для сообщения
  var $message = $('<div class="alert alert-danger" style="position: fixed; top: 20px; right: 20px; z-index: 9999; padding: 15px; border-radius: 5px; background: #f8d7da; color: #721c24; border: 1px solid #f5c6cb;">' + message + '</div>');
  
  // Добавляем на страницу
  $('body').append($message);
  
  // Удаляем через 5 секунд
  setTimeout(function() {
    $message.fadeOut(function() {
      $(this).remove();
    });
  }, 5000);
}

/************************* */
function update_block(block_id,action){

  if(action == 'edit'){
    $( "#" + block_id ).removeClass('d_view');
    $( "#" + block_id ).addClass('d_edit');
  }else if(action == 'view'){
    $( "#" + block_id ).removeClass('d_edit');
    $( "#" + block_id ).addClass('d_view');
  } else {
    if( $( "#" + block_id ).hasClass('d_view') ){
      $( "#" + block_id ).removeClass('d_view');
      $( "#" + block_id ).addClass('d_edit');
    }else{
      $( "#" + block_id ).removeClass('d_edit');
      $( "#" + block_id ).addClass('d_view');
    }
  }
}
/************************* */

/**
 * Re-order functionality
 * Adds all items from a previous order to the cart
 */
$(document).on('click', '.reorder-btn', async function(e) {
  e.preventDefault();

  const $btn = $(this);
  const $textSpan = $btn.find('.reorder-btn__text');
  const $loadingSpan = $btn.find('.reorder-btn__loading');
  const $errorContainer = $btn.closest('.reorder-section').find('.reorder-error');
  const originalText = $btn.text().trim();

  // Set loading state
  $btn.prop('disabled', true);
  if ($textSpan.length && $loadingSpan.length) {
    $textSpan.hide();
    $loadingSpan.show();
  } else {
    $btn.text('Adding...');
  }
  if ($errorContainer.length) {
    $errorContainer.hide().text('');
  }

  try {
    // Parse payload from data attribute
    const payload = $btn.attr('data-reorder-payload');
    const items = JSON.parse(payload);

    if (!items || items.length === 0) {
      throw new Error('No items available to re-order');
    }

    // Get the correct route (supports multi-language stores)
    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    // Add items to cart via batch API
    const response = await fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    const data = await response.json();

    if (response.ok) {
      // Success - redirect to cart
      window.location.href = rootUrl + 'cart';
    } else {
      // Handle API errors (e.g., out of stock)
      console.error('Re-order API Error:', data);
      let errorMessage = 'Some items could not be added.';
      if (data.description) errorMessage = data.description;
      if (data.message) errorMessage = data.message;
      throw new Error(errorMessage);
    }

  } catch (error) {
    console.error('Re-order error:', error);

    // Show error message
    if ($errorContainer.length) {
      $errorContainer.text(error.message).show();
    } else {
      showErrorMessage(error.message);
    }

    // Reset button
    $btn.prop('disabled', false);
    if ($textSpan.length && $loadingSpan.length) {
      $loadingSpan.hide();
      $textSpan.show();
    } else {
      $btn.text(originalText);
    }
  }
});

// Contact form submission tracking (to show correct success message)
$(document).ready(function() {
  // Track which contact form was submitted
  $('.return-request-form').on('submit', function() {
    sessionStorage.setItem('submittedForm', 'returns');
  });

  $('.gdpr-contact-form').on('submit', function() {
    sessionStorage.setItem('submittedForm', 'gdpr');
  });

  // On page load, check which form was submitted and handle success messages
  var submittedForm = sessionStorage.getItem('submittedForm');

  if (submittedForm) {
    // Hide success messages on forms that weren't submitted
    if (submittedForm === 'returns') {
      $('.gdpr-contact-form .form-success-message').hide();
      // Navigate to returns tab if success message is showing
      if ($('.return-form-success').length) {
        // Trigger click on returns menu item to show correct tab
        $('.menu_return').click();
      }
    } else if (submittedForm === 'gdpr') {
      $('.return-request-form .return-form-success').hide();
      // Navigate to GDPR tab if success message is showing
      if ($('.gdpr-contact-form .form-success-message').length) {
        $('.menu_gdpr').click();
      }
    }

    // Clear the stored value
    sessionStorage.removeItem('submittedForm');
  }
});
